import { geocoderAPI } from "../geocoderApi"

export const geocoderApiSlice = geocoderAPI.injectEndpoints({
    endpoints: builder => ({
        getSearchResults: builder.query<any, any>({
            query: (args) => ({
                url: `getSearchResults?name=${args?.name}`
            })
        }),
        fetchGeoAddress: builder.query<any, any>({
            query: ({ latitude, longitude }) => ({
                url: `getGeoAddress`,
                params: {
                    lat: latitude,
                    lon: longitude
                }
            })
        })
    })
})

export const {
    useLazyGetSearchResultsQuery,
    useFetchGeoAddressQuery,
    useLazyFetchGeoAddressQuery,
} = geocoderApiSlice
